module.exports = __webpack_public_path__ + "static/media/felix.0947e7e4.svg";